import React from 'react';
import { Link } from 'react-router-dom';

const PageBanner = ({ title, text, image }) => {
    return (
        <section
            className="page-banner"
            style={{
                backgroundImage: `linear-gradient(90deg, rgba(8, 16, 28, 0.78), rgba(8, 16, 28, 0.45)), url(${process.env.PUBLIC_URL}${image})`,
            }}
        >
            <div className="container hero-enter">
                <p className="eyebrow">
                    <Link to="/">Home</Link>
                    <span> / {title}</span>
                </p>
                <h1>{title}</h1>
                {text && <p>{text}</p>}
            </div>
        </section>
    );
};

export default PageBanner;
